import React from 'react';

import { useTranslation } from 'react-i18next';
import { Button, Flex, VStack } from '@tq/ui-components';
import { RecoilState, useRecoilState } from 'recoil';
interface RowEditButtonsProps {
  rowIndex: number;
  width: number;
  editingState: RecoilState<number | undefined>;
  submit: () => void;
  handleDelete?: () => void;
  disabled: boolean;
  hideDelete?: boolean;
}

export const RowEditButtons: React.FC<RowEditButtonsProps> = ({
  rowIndex,
  width,
  editingState,
  submit,
  handleDelete,
  disabled,
  hideDelete,
}) => {
  const { t } = useTranslation('create_organisation');
  const [editing, setEditing] = useRecoilState(editingState);

  const handleEdit = () => {
    setEditing(rowIndex);
  };

  const handleCancel = () => {
    setEditing(undefined);
  };

  return editing === rowIndex ? (
    <VStack width={`${width - 32}px`}>
      <Button
        disabled={disabled}
        onClick={submit}
        size='md'
        minWidth={`${width - 32}px !important`}
      >
        {t('update', 'Update')}
      </Button>
      <Button
        size='md'
        minWidth='150px !important'
        width='100%'
        variant='secondary'
        onClick={handleCancel}
      >
        {t('cancel', 'Cancel')}
      </Button>
    </VStack>
  ) : (
    <Flex gap={5}>
      {!hideDelete && (
        <Button variant='secondary' size='xs' onClick={handleDelete}>
          {t('delete', 'Delete')}
        </Button>
      )}
      <Button variant='secondary' size='xs' onClick={handleEdit}>
        {t('edit', 'Edit')}
      </Button>
    </Flex>
  );
};
